import { apiClient, ApiResponse } from './apiClient';

export interface CreateAppointmentClosureData {
  appointmentId: string;
  clinicalSummary: string;
  finalNotes?: string;
  patientGuidance?: string;
  followUpRequired: boolean;
  followUpType?: 'days' | 'weeks' | 'months' | 'exact' | null;
  suggestedFollowUpDate?: string | null;
  noFollowUpNeeded?: boolean;
  internalObservation?: string;
  evolutionContent: string;
}

export interface AppointmentClosureDTO {
  id: string;
  appointmentId: string;
  doctorId: string;
  patientId: string;
  clinicalSummary?: string;
  finalNotes?: string;
  patientGuidance?: string;
  followUpRequired: boolean;
  followUpType?: 'days' | 'weeks' | 'months' | 'exact' | null;
  suggestedFollowUpDate?: string | null;
  noFollowUpNeeded: boolean;
  internalObservation?: string;
  createdAt: string;
  updatedAt: string;
}

export const closuresService = {
  /**
   * Registra o fechamento clínico e finaliza a consulta
   */
  createClosure: async (data: CreateAppointmentClosureData): Promise<ApiResponse<AppointmentClosureDTO>> => {
    return apiClient.post('/appointment-closures', data);
  },

  /**
   * Busca o fechamento clínico de uma consulta específica
   */
  getClosureByAppointmentId: async (appointmentId: string): Promise<ApiResponse<AppointmentClosureDTO>> => {
    return apiClient.get(`/appointment-closures/appointment/${appointmentId}`);
  },
};
